<template>
  <BModal
    ref="modalDocuments"
    size="xl"
    scrollable
    hide-header
    no-close-on-backdrop
    modal-class="full-screen"
  >
    <BCarousel
      id="carouselDocuments"
      v-model="carousel"
      controls
      indicators
      no-touch
      class="h-100"
      background="#aaa"
      :interval="1000000"
    >
      <BCarouselSlide
        v-for="(file, key) in attachments"
        :key="`uploaded-${key}`"
        :caption="file.file_original_name"
        :text="`File Size: ${Number(file.file_size / 1000).toFixed(2)} KB, Document Type: ${file?.document_type_name || 'No Type'}`"
        caption-tag="h6"
        style="min-height: calc(100vh - 85px);"
      >
        <template #img>
          <div
            class="d-flex justify-content-center align-items-center"
          >
            <panZoom
              :options="{
                minZoom: 0.5,
                maxZoom: 5,
                bounds: true,
                boundsPadding: 0.5
              }"
            >
              <BImg
                class="d-blocks"
                :src="uploadedDocumentEndpoint(file.file_hashed_name)"
              />
            </panZoom>
          </div>
        </template>
      </BCarouselSlide>
    </BCarousel>
    <template #modal-footer="{ cancel }">
      <div class="col-12 d-flex justify-content-between px-0 pb-0 mb-0">
        <div />
        <div>
          <BButton
            variant="outline-dark"
            :disabled="busy"
            @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
          >
            Close <span class="d-none d-md-inline-block">Preview</span>
          </BButton>
        </div>
      </div>
    </template>
  </BModal>
</template>
<script>
import MMisc from '@/mixins/misc'

export default {
  name: 'ASMPreview',

  mixins: [
    MMisc
  ],

  data () {
    return {
      busy: false,
      carousel: 0,
      attachments: [],
      attachmentPath: ''
    }
  },
  methods: {
    uploadedDocumentEndpoint (fileName) {
      return `${process.env.VUE_APP_API_BASE_URL}/${this.attachmentPath}/${fileName}`
    },

    show (attachments = [], attachmentPath = '', index = 0) {
      this.attachments = attachments
      this.attachmentPath = attachmentPath
      this.carousel = Number(index)

      this.$refs.modalDocuments.show()
    }
  }
}
</script>
